// Bucket bounds MUST stay in sync with _MC_BUCKETS in web/backend/routers/backtesting.py.
export const MC_PRESETS = [
  { label: 'Mega',      min: 200e9,      max: 1e15 },
  { label: 'Large',     min: 10e9,       max: 200e9 },
  { label: 'Mid',       min: 2e9,        max: 10e9 },
  { label: 'Small',     min: 300e6,      max: 2e9 },
];

export function canonCapBuckets(list) {
  const known = new Map(MC_PRESETS.map(p => [p.label.toUpperCase(), p.label]));
  const out = [];
  const seen = new Set();
  for (const raw of (Array.isArray(list) ? list : [])) {
    const key = String(raw).trim().toUpperCase();
    if (!key || key === 'CUSTOM' || seen.has(key)) continue;
    seen.add(key);
    out.push(known.get(key) || String(raw).trim());
  }
  return out;
}

